import {
  ButtonSecondary,
  ButtonSize,
  Currency,
  formatBalance,
  IconBlock,
  IconSelected,
} from '@ui/src';
import { Balance, CustomerStatus } from '../../types';

import cn from '../styles.module.css';

interface CurrencyItem extends Currency {
  render?: Record<string, React.JSX.Element>;
}

const formatCurrencies = (
  currencies: CurrencyItem[],
  balances: Balance[],
  setBlockPopupVisible: (data: boolean) => void,
  setSelectedBlockCurrency: (data: Currency) => void,
  setEnablePopupVisible: (data: boolean) => void,
  setSelectedEnableCurrency: (data: Currency) => void,
  status?: CustomerStatus,
) => {
  const nextList = currencies?.map((item) => {
    const result = { ...item };

    const currentBalance = balances?.find(
      (balance) => balance.currencyId === item.id,
    );

    const render: Record<string, React.JSX.Element> = {
      name: (
        <div className={!currentBalance ? cn.disabledBalance : ''}>
          {result.name}
        </div>
      ),
      description: (
        <div className={!currentBalance ? cn.disabledBalance : ''}>
          {result.description}
        </div>
      ),
      decimals: (
        <div className={!currentBalance ? cn.disabledBalance : ''}>
          {currentBalance
            ? formatBalance(currentBalance?.value || 0, item)
            : '-'}
        </div>
      ),
      code: (
        <div
          className={`${cn.availableRow} ${
            !currentBalance ? cn.disabledBalance : ''
          }`}
        >
          <div>{currentBalance ? 'Available' : 'Unavailable'}</div>
          <ButtonSecondary
            className={`${cn.activateButton} button-white`}
            text={currentBalance ? 'Disable' : 'Enable'}
            icon={
              currentBalance ? (
                <IconBlock className={cn.blockIcon} />
              ) : (
                <IconSelected />
              )
            }
            size={ButtonSize.SMALL}
            onClick={() => {
              if (currentBalance) {
                setBlockPopupVisible(true);
                setSelectedBlockCurrency(item);
              } else {
                setEnablePopupVisible(true);
                setSelectedEnableCurrency(item);
              }
            }}
            disabled={
              Boolean(currentBalance && currentBalance?.value) ||
              status === CustomerStatus.CLOSED
            }
          />
        </div>
      ),
    };

    result.render = render;

    return result;
  });

  return nextList;
};

export default formatCurrencies;
